























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { FitIcon } from '@tencent/wphk-ui';
import { NoticeProps } from './type';

@Component({
  components: {
    FitIcon,
  },
})
export default class TopNotice extends Vue {
  @Prop() content!: string;
  /** 主题色 */
  @Prop({ default: 'warn' }) theme!: NoticeProps['theme'];
  /** 左侧icon类型 */
  @Prop({ default: '' }) leftIconType!: NoticeProps['leftIconType'];
  /** 右侧icon类型 */
  @Prop({ default: '' }) rightIconType!: NoticeProps['rightIconType'];

  get hasContentOnly() {
    return !this.leftIconType && !this.rightIconType;
  }

  /* 返回左侧按钮的iconfont class */
  get leftIconName() {
    switch (this.leftIconType) {
      case 'notice':
        return 'notice';
      case 'error':
        return 'exclamation';
      default:
        return '';
    }
  }

  /* 返回右侧按钮的 iconfont class */
  get rightIconName() {
    switch (this.rightIconType) {
      case 'delete':
        return 'delete';
      case 'arrow':
        return 'arrow-right';
      default:
        return '';
    }
  }

  @Emit('onRightIcon')
  onRightIcon() {
    return this.rightIconType;
  }

  @Emit('onClick')
  onClick(e: Event) {
    return e;
  }
}
